import { graphql } from 'gql.tada';
import { client } from '../client';

export const sendEmailMutation = graphql(`
  mutation SendEmail($input: SendEmailInput!) {
    sendEmail(input: $input) {
      status
    }
  }
`);

export const sendEmailMutationFn = (input: SendEmailVariables['input']) =>
  client.request(sendEmailMutation, {
    input,
  });

/* eslint-disable typescript/no-explicit-any -- Required for gql.tada type inference */
export type SendEmailVariables =
  typeof sendEmailMutation extends import('gql.tada').TadaDocumentNode<
    any,
    infer T,
    any
  >
    ? T
    : never;
/* eslint-enable typescript/no-explicit-any */
